import { createAsyncThunk } from "@reduxjs/toolkit";
import { businessSearch, createPublicReport, searchAddressApi, getPlaceDetailsApi } from "../apis/GuestApi";
const GUEST_BUSINESS_SEARCH = "guest/business_search";
const GUEST_CREATE_PUBLIC_REPORT = "guest/create_public_report";

export const businessSearchAction = createAsyncThunk(
    GUEST_BUSINESS_SEARCH,
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await businessSearch(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "Register failed" });
        }
    }
);

export const searchAddressAction = createAsyncThunk("search/address", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await searchAddressApi(payload)
            return response.data;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Search address failed" });
    }
})

export const createPublicReportAction = createAsyncThunk(
    GUEST_CREATE_PUBLIC_REPORT,
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await createPublicReport(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "Register failed" });
        }
    }
);
export const getPlaceDetailsAction = createAsyncThunk(
    "guest/place_details",
    async (payload: { placeId: string; sessionToken?: string }, { rejectWithValue }) => {
        try {
            const response = await getPlaceDetailsApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "Get place details failed" });
        }
    }
);
